<template>
  <div class="ts">
    <p v-if="procList && procList.length <= 0" style="margin-top: 10px;margin-left: 20px;">没有数据...</p>
    <div class="t" :class="{'a' : proc.procInstId == dingweiProcId, 'rc-t': listKey === 'record' && proc.isTongguo,'rc-f': listKey === 'record' && !proc.isTongguo}" v-for="(proc, i) in procList"
         @click="openProc(proc)"
         :proc-inst-id="proc.procInstId"
         :key="i">
      <div class="item-title c">
        <div class="c">
          <p v-if="proc.data">{{ proc.data.title }}{{ proc.data.subTitle && ('-' + proc.data.subTitle) || '' }}</p>
          <p class="money">{{ getMoney(proc.data) }}</p>
          <p class="sub-title">{{ getBiaotou(proc.data) }}</p>
        </div>
        <div class="u y" @mouseenter="$tip(proc.createTime || proc.startTime)">
          <div class="sp"><p>创建时间：{{ friendlyDate(proc.createTime || proc.startTime) }}</p></div>
        </div>
      </div>
      <div class="v-u">
        <div class="u y">
          <div class="sp c" v-if="proc.actRuTask">
            <p class="ing c" @mouseenter="$tip('当前任务节点')">
              <img alt="" src="@/assets/imgs/todo.svg">{{ proc.actRuTask.name === '填写表单' && '重新' || '' }}{{ proc.actRuTask.name }}
            </p>
            <p class="sub-title" @mouseenter="$tip('申请被驳回的原因')"
               v-if="(proc.actRuTask.name === '填写表单' || proc.actRuTask.name === '填写采购表单') && proc.data && proc.data.bohuiType">
              {{ getLastBohuiyuanyin(proc) }}
            </p>
          </div>
          <div class="sp c" v-else>
            <p class="ing c" @mouseenter="$tip('当前任务节点')">
              <img alt="" src="@/assets/imgs/done.svg">{{ '已完成' }}
            </p>
          </div>
        </div>
        <div class="u sq-btns">
          <div v-if="!proc.isEnd && isMineInitiate(proc) && !isSubmitForm(proc)" class="btn btn-cancel active" @click.stop="cancelProc(proc, i)">
            <p class="c"><img alt="" src="@/assets/imgs/cancel.svg">撤销</p>
          </div>
          <div v-if="!proc.isEnd && isMineInitiate(proc)" class="btn btn-cancel active" @click.stop="removeProc(proc, i)">
            <p class="c"><img alt="" src="@/assets/imgs/del.svg">删除</p>
          </div>
          <div class="btn active" @click.stop="showHistoryTip(proc, 'proc-his' + i)" :t-id="'proc-his' + i">
            <p class="c"><img alt="" src="@/assets/imgs/time.svg">记录</p>
          </div>
        </div>
        <div class="rc-tg" v-if="listKey === 'record'">
          {{ proc.isTongguo ? '通过' : '驳回' }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import util from "@/util";

export default {
  data() {
    return {};
  },
  props: ['procList', 'dingweiProcId', 'listKey'],
  inject: ['componentShenpi'],
  computed: {
    user() {
      return this.$store.state.user;
    }
  },
  methods: {
    getMoney(data) {
      if (!data) return ''
      return util.toFiexd(data.jine, util.getCurrencyCode(data.currency));
    },
    getBiaotou(data) {
      if (!data) return ''
      let res = '';
      res += (data.shoukuan || '') + ' ' + (data.yuanyin || '') + util.toFiexd(data.jine, util.getCurrencyCode(data.currency));
      data.yongtus && data.yongtus.forEach(item => {
        res += item.name + ' ' + util.toFiexd(item.jine, util.getCurrencyCode(data.currency)) + ' ';
      });
      data.kuanxiangs && data.kuanxiangs.forEach(item => {
        res += item.name + ' ' + util.toFiexd(item.jine, util.getCurrencyCode(data.currency)) + ' ' + item.bumen + ' ';
      });
      // data.kuanxiangsGz && data.kuanxiangsGz.forEach(item => {
      //   res += item.bumen + ' ' + util.toFiexd(item.jine, util.getCurrencyCode(data.currency)) + ' ';
      // });
      data.caigouQingdanGyl && data.caigouQingdanGyl.forEach(item => {
        res += item.name + ' ' + util.toFiexd(item.danjia, util.getCurrencyCode(data.currency)) + ' * ' + item.shuliang + ' ';
      });
      data.caigous && data.caigous.forEach(item => {
        res += (item.name || item.pinming || '') + ' ' + item.sku + ' ' + util.toFiexd(item.danjia, util.getCurrencyCode(data.currency)) + ' * ' + item.shuliang + ' ';
      });
      return res;
    },
    friendlyDate(date) {
      return util.friendlyDate1(date)
    },
    getLastBohuiyuanyin(proc) {
      let map = {
        'zhuguan': 'bohuiYuanyinZhuguan',
        'zongcai': 'bohuiYuanyinZongcai',
        'caigou': 'bohuiYuanyinCaigou',
        'caiwu': 'bohuiYuanyinCaiwu',
        'chuna': 'bohuiYuanyinChuna',
        'zongjingban': 'bohuiYuanyinZongjingban',
        'zhuguanCaigou': 'bohuiYuanyinZhuguanCaigou',
        'zongjingbanCaigou': 'bohuiYuanyinZongjingbanCaigou',
        'renshi': 'bohuiYuanyinRenshi',
        'caiwujingli': 'bohuiYuanyinCaiwujingli',
        'lingdao': 'bohuiYuanyinLingdao',
        'kaifayuan': 'bohuiYuanyinKaifayuan',
        'yunying': 'bohuiYuanyinYunying',
        'yunyingzuzhang': 'bohuiYuanyinYunyingzuzhang',
        'fbaCaigouqueren': 'bohuiYuanyinFbaCaigouqueren',
        'gongyinglianZhuguan': 'bohuiYuanyinGongyinglianZhuguan'
      };
      let field = map[proc.data.bohuiType];
      let yuanyin = proc.data[field];
      if (yuanyin)
        return ' - ' + yuanyin;
      return '';
    },
    isMineInitiate(proc) {
      return this.user && proc.startUserId === this.user.name
    },
    openProc(proc) {
      this.$router.push({
        name: '流程',
        params: {
          id: proc.procInstId ? proc.procInstId : 0,
          isCC: this.listKey === 'tome', // 是否是抄送的流程
          backUrlName: '审批系统'
        }
      })
    },
    cancelProc(proc) {
      window.layer.confirm('撤销后将回退到重新填写表单，确认撤销？', () => {
        util.loadBegin();
        this.$get('/sp/process/cancel', { taskId: proc.actRuTask.id }, () => {
          this.componentShenpi.loadAllData()
          util.loadClose()
        }, () => {
          util.loadClose()
        })
      })
    },
    removeProc(proc, i) {
      console.log(proc, i)
      window.layer.confirm('删除后不可恢复，确认删除？', () => {
        util.loadBegin();
        this.$get('/sp/process/del', { id: proc.procInstId }, () => {
          this.componentShenpi.loadAllData()
          util.loadClose()
        }, () => {
          util.loadClose()
        })
      })
    },
    showHistoryTip(proc) {
      return this.componentShenpi.showHistoryTip(proc);
    },
    isSubmitForm(proc) {
      return proc && proc.actRuTask && (proc.actRuTask.taskDefKey === 'tianxieForm' || proc.actRuTask.taskDefKey === 'tianxieCaigouForm')
    }
  },
  mounted() {
  },
  created() {
  },
  destroyed() {
  },
};
</script>
<style scoped>
.t {
  height: auto
}

.money {
  color: #cc861d;
  font-weight: bold;
  margin-left: 5px;
}

@media only screen and (max-width: 749px) {
  .t {
    margin: 0 0 5px;
  }
}
</style>
